export default "__VITE_ASSET__D8wm1Qit__"